import { TaskLocationStatus } from '@ml/tasks/types/enums/task-location-status.enum';
import { OrderLocation } from '@ml/orders/types/classes';

export class TaskLocation {
  id: number;
  status: TaskLocationStatus;
  orderLocation: OrderLocation | number;
  task: number;
}
